export default __webpack_public_path__ + "static/media/Q2 Power AG.591977cf.svg";